<script setup>
import {Link} from '@inertiajs/vue3';

defineProps({
    href: String,
    as: String,
});
</script>

<template>
    <div>
        <button v-if="as === 'button'" type="submit" class="whitespace-nowrap block w-full px-4 py-2 text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-hidden focus:bg-gray-100 dark:text-white dark:hover:text-deep-blue transition duration-150 ease-in-out">
            <slot />
        </button>

        <a v-else-if="as ==='a'" :href="href" class="whitespace-nowrap block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-hidden focus:bg-gray-100 transition duration-150 ease-in-out">
            <slot />
        </a>

        <Link v-else :href="href" class="whitespace-nowrap block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-hidden focus:bg-gray-100 transition duration-150 ease-in-out">
            <slot />
        </Link>
    </div>
</template>
